import { render, staticRenderFns } from "./EditText.vue?vue&type=template&id=2fadc956&scoped=true&"
import script from "./EditText.vue?vue&type=script&lang=js&"
export * from "./EditText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadc956",
  null
  
)

export default component.exports